import { useEffect, useState } from "react";

const getIsMobile = () => window.innerWidth <= 599;

export default function IsMobile(inverse = false) {
    const [isMobile, setIsMobile] = useState(getIsMobile());

    useEffect(() => {
        const onResize = () => {
            setIsMobile(getIsMobile());
        }

        window.addEventListener("resize", onResize);
    
        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);
    
    if(inverse)
        return !isMobile
    
    return isMobile;
}